/* eslint-disable react/prop-types */
import { PaidMethod } from '@constants';
import ErrorIcon from '@mui/icons-material/Error';
import { Panel } from '../panel';
import classes from './index.module.css';
import { paymentMethods } from '../../pages/payment/const';
import { TREMENDOUS_HOVER } from '../../constants/claim';

/** 获取金额的有效值 */
const getValidMoneyValue = (value) => {
  if (!value) {
    return '--';
  }
  if (Number.isNaN(Number(value))) {
    return value;
  }
  return `${Number(value).toFixed(2)}`;
};

// eslint-disable-next-line max-len
// const getResolutionValue = (resolution) => (resolution === PaidMethod.Tremendous ? 'Refund via virtual visa card' : 'To be determined');

/** BP review 面板 */
export const BPReviewPanel = ({ reviewInfo }) => {
  if (!reviewInfo) {
    return null;
  }

  const { refundTotalValue, resolution } = reviewInfo || {};
  // 兼容老逻辑 原来resolution 返回的是显示文案，rc2.0改成返回payment code，所以兼容老逻辑，使得正常显示resolution文案
  const { title = resolution, time } = paymentMethods[resolution] || {};

  return (
    <Panel>
      <section className={classes.reported_title}>
        <span className={classes.title_bold}>Estimated refund:</span>
        <span>
          {refundTotalValue}
        </span>
      </section>
      <section className={classes.bp_resolution}>
        <section className={classes.resolution_title}>
          <span className={classes.title_bold}>Transfer method:</span>
          <span className={classes.method}>
            {title}
            {/*  payment 选择Direct payment via your preferred method 才显示hover */}
            {resolution === PaidMethod.Tremendous && (
              <span className={classes.info_icon}>
                <ErrorIcon
                  fontSize="small"
                  sx={{
                    '&': {
                      color: '#5C5F62',
                      marginLeft: '4px',
                    },
                  }}
                />
                <span className={classes.hover_text}>
                  <section className={classes.hover_text_tip}>
                    {TREMENDOUS_HOVER}
                  </section>
                  <section className={classes.hover_triangle} />
                </span>
              </span>
            )}
          </span>

        </section>

        {time
          && (
            <span className={classes.processing_time}>
              {time}
            </span>
          )}
      </section>
    </Panel>
  );
};

/** RA review 面板 */
export const RAReviewPanel = ({ reviewInfo, platform }) => {
  if (!reviewInfo) {
    return null;
  }
  const {
    refundTotalValue, itemTotalValue, taxInclude, tax, shippingFee, resolution,
    payment: { time, title } = {},
  } = reviewInfo || {};
  const resolutionTitle = platform ? 'Transfer method:' : 'Resolution:';
  const method = platform === 'gently' ? title : resolution;

  const footer = (
    <section className={classes.resolution}>
      <section className={classes.resolution_title}>
        <span className={classes.title_bold}>{resolutionTitle}</span>
        <span>{method}</span>
      </section>

      {platform && time
        && (
          <span className={classes.processing_time}>
            {time}
          </span>
        )}
    </section>
  );

  return (
    <Panel footer={footer}>
      <section className={`${classes.title_bold} ${classes.reported_ra_title}`}>Estimated refund</section>
      <section className={classes.reported_line}>
        <section>Items subtotal</section>
        <section className={classes.reported_money}>{getValidMoneyValue(itemTotalValue)}</section>
      </section>
      <section className={classes.reported_line}>
        <section>
          Tax
          {taxInclude ? ' (included)' : ''}
        </section>
        <section className={classes.reported_money}>{getValidMoneyValue(tax)}</section>
      </section>
      <section className={classes.reported_line}>
        <section>Return shipping fee (Label generated by Seel)</section>
        <section className={classes.reported_money}>{shippingFee ? `${getValidMoneyValue(shippingFee)}` : '--'}</section>
      </section>
      <section className={classes.reported_line}>
        <section className={classes.title_bold}>Total</section>
        <section className={classes.title_bold} style={{ marginRight: '0px' }}>
          {getValidMoneyValue(refundTotalValue)}
        </section>
      </section>
    </Panel>
  );
};
